import temporarySideAdImage from '../img/reklama.png';

export const sideAds = {
  enabled: process.env.REACT_APP_SIDE_ADS_ENABLED !== 'false',
  desktopMinWidth: 1536,
  backgroundSize: '200% auto',
  left: {
    image: process.env.REACT_APP_SIDE_AD_LEFT_IMAGE || temporarySideAdImage,
  },
  right: {
    image: process.env.REACT_APP_SIDE_AD_RIGHT_IMAGE || temporarySideAdImage,
  },
};

export const hasSideAdCampaign = (config = sideAds) => Boolean(
  config.enabled
  && config.left?.image
  && config.right?.image
);
